import { HiringGoal as ActiveHiringGoal } from 'api-clients/monolith';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import EditPencil from '@/assets/icons/edit-pencil.svg';
import { useHireUrl } from '@/hooks/use-hire-url';
import { formatShortDate } from '@/utils/date-util';
import { getProgress } from '@/utils/progress';

import { Button } from './button';
import { Progress } from './progress';
import { Typography } from './typography';

interface HiringGoalProps {
  hiringGoal?: ActiveHiringGoal | null;
  brand?: string;
  location?: string;
  funnel?: string;
}

export function HiringGoal({
  hiringGoal,
  brand,
  location,
  funnel,
}: HiringGoalProps) {
  const { getHireATHiringGoalUrl } = useHireUrl();

  if (!hiringGoal)
    return (
      <Button variant="link" asChild>
        <Link
          to={getHireATHiringGoalUrl(brand ?? 'no_brand', location, funnel)}
          target="_blank"
        >
          <FormattedMessage
            defaultMessage="+ Add hiring goal"
            description="Link in table when a row has no hire-by goal in Hire"
          />
        </Link>
      </Button>
    );

  const progress = getProgress(hiringGoal.goal, hiringGoal.hires_count);

  return (
    <div className="flex items-center gap-2">
      <div className="flex flex-col gap-1">
        <div className="flex flex-row justify-between gap-5">
          <Typography variant="subtitle1">
            {hiringGoal.hires_count} of {hiringGoal.goal}
          </Typography>

          {hiringGoal.hire_by && (
            <Typography variant="subtitle1">
              {formatShortDate(hiringGoal.hire_by)}
            </Typography>
          )}
        </div>

        <Progress value={progress} />
      </div>

      <Button variant="icon" asChild className="h-7 w-7 rounded-full p-1">
        <Link
          to={getHireATHiringGoalUrl(brand ?? 'no_brand', location, funnel)}
          target="_blank"
        >
          <img src={EditPencil} alt="Edit" />
        </Link>
      </Button>
    </div>
  );
}
